import { createContext } from "react";
import { ChildForm, SchemaDB } from "../../interfaces/schemaDB";
import { TableDB } from '../../../src/interfaces/schemaDB';

//esto es todo lo que devuelve el contexto, pueden ser estados o funciones
interface SchemaDBContextProps {
    schemaDBState : SchemaDB
    setSchemaDBState( schema : SchemaDB ) : void;
    childrenTables : ChildForm[]
    setCurrentChildrenTables( tables:ChildForm[] ) : void;
    // addTableSchema( table: TableDB | undefined) : void;
}

export const SchemaDBContext = createContext<SchemaDBContextProps>({ } as SchemaDBContextProps);

